import { render, staticRenderFns } from "./renewList.vue?vue&type=template&id=1f2e6578&scoped=true"
import script from "./renewList.vue?vue&type=script&lang=js"
export * from "./renewList.vue?vue&type=script&lang=js"
import style0 from "./renewList.vue?vue&type=style&index=0&id=1f2e6578&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e6578",
  null
  
)

export default component.exports